import p from "preact";

const Facebook = ({ color = "#788391" }) => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-211.000000, -655.000000)" fill={color}>
          <g transform="translate(211.000000, 655.000000)">
            <path d="M0,16 C0,7.16344357 7.16344357,0 16,0 C24.8365564,0 32,7.16344357 32,16 C32,24.8365564 24.8365564,32 16,32 C7.16344357,32 0,24.8365564 0,16 Z M17.1343701,24.8743178 L17.1343701,16.1694731 L19.5372879,16.1694731 L19.8557264,13.1697354 L17.1343701,13.1697354 L17.1384526,11.6683378 C17.1384526,10.88596 17.2127889,10.4667441 18.3365094,10.4667441 L19.8387158,10.4667441 L19.8387158,7.46666667 L17.4354577,7.46666667 C14.5487583,7.46666667 13.532715,8.92186219 13.532715,11.3690434 L13.532715,13.1700751 L11.7333333,13.1700751 L11.7333333,16.1698128 L13.532715,16.1698128 L13.532715,24.8743178 L17.1343701,24.8743178 Z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Facebook;



// WEBPACK FOOTER //
// ./assets/icons/Facebook.js